"use strict";

export function initInScope ($scope) {
    let $container = $scope.find('.js-open-personalization-modal-by-default');
    let modal = $container.attr('data-open-personalized-modal');

    $(modal).modal('show');
}